import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/logo-animation.json';

const LoadingScreen = ({ onComplete }) => {
    const [isFadingOut, setIsFadingOut] = useState(false);

    const handleAnimationComplete = () => {
        // Wait 0.2 seconds after animation ends
        setTimeout(() => {
            setIsFadingOut(true);
            // Wait for fade out animation to finish before unmounting
            setTimeout(() => {
                if (onComplete) onComplete();
            }, 500); // 500ms matches the transition duration
        }, 200);
    };

    return (
        <div
            className={`fixed inset-0 z-[100] flex items-center justify-center bg-primary-navy transition-opacity duration-500 ease-in-out ${isFadingOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
                }`}
        >
            {/* Grainy overlay that becomes visible during the dissolve */}
            <div
                className={`absolute inset-0 z-0 pointer-events-none transition-opacity duration-300 ${isFadingOut ? 'opacity-50' : 'opacity-0'
                    }`}
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
                }}
            />

            {/* We use scale to visually enlarge it on mobile beyond viewport limits, while keeping standard px boundaries to prevent scrollbars */}
            <div className="relative z-10 w-[400px] h-[400px] sm:w-[500px] sm:h-[500px] md:w-[768px] md:h-[768px] lg:w-[800px] lg:h-[800px] flex items-center justify-center scale-150 md:scale-100 overflow-hidden">
                <Lottie
                    animationData={animationData}
                    loop={false}
                    onComplete={handleAnimationComplete}
                    style={{ width: '100%', height: '100%' }}
                />
            </div>
        </div>
    );
};

export default LoadingScreen;
